// gatsby-browser.js

exports.onClientEntry = () => {
    console.log(
      "%cmeridian%c \nby RDS Corp.  %c\n\nSite design & dev by RDS Corp.  %c\n\nVisit: https://rajputanards.com for more info.\nWanna get in touch? Contact: info@rajputanards.com",
      "color:rgb(233, 189, 29); font-size: 70px; font-weight: bold; font-family: 'Trebuchet MS';",
      "color:rgb(130, 130, 130); font-size: 22px; font-family: Arial;",
      "color: rgba(130, 130, 130, 0.5);; font-size: 17px; font-family: Arial;",
      "color: rgba(130, 130, 130, 0.5);; font-size: 13px; font-style: italic; font-family: Arial;",
    );
  };
  